<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 15C16.7167 15 16.4792 14.9042 16.2875 14.7125C16.0958 14.5208 16 14.2833 16 14V10C16 9.71667 16.0958 9.47917 16.2875 9.2875C16.4792 9.09583 16.7167 9 17 9H20C20.2833 9 20.5208 9.09583 20.7125 9.2875C20.9042 9.47917 21 9.71667 21 10V11H19.5V10.5H17.5V13.5H19.5V13H21V14C21 14.2833 20.9042 14.5208 20.7125 14.7125C20.5208 14.9042 20.2833 15 20 15H17ZM9.5 15V9H13.5C13.7833 9 14.0208 9.09583 14.2125 9.2875C14.4042 9.47917 14.5 9.71667 14.5 10V11C14.5 11.2833 14.4042 11.5208 14.2125 11.7125C14.0208 11.9042 13.7833 12 13.5 12C13.7833 12 14.0208 12.0958 14.2125 12.2875C14.4042 12.4792 14.5 12.7167 14.5 13V14C14.5 14.2833 14.4042 14.5208 14.2125 14.7125C14.0208 14.9042 13.7833 15 13.5 15H9.5ZM11 11.25H13V10.5H11V11.25ZM11 13.5H13V12.75H11V13.5ZM3 15V10C3 9.71667 3.09583 9.47917 3.2875 9.2875C3.47917 9.09583 3.71667 9 4 9H7C7.28333 9 7.52083 9.09583 7.7125 9.2875C7.90417 9.47917 8 9.71667 8 10V15H6.5V13.5H4.5V15H3ZM4.5 12H6.5V10.5H4.5V12Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
